/**
 * @parent anybody
 * @children
 * @stateful
 * @stateless
 */
import React, { PropTypes } from 'react';
import classnames from 'classnames'
import Float from 'components/UI/Float';
import './RegistrationTableFloat.scss';
import moment from 'moment';
import { Button } from 'components/UI';


class RegistrationTableFloat extends React.Component {
  static propTypes = {

  }

  static defaultProps = {

  }

  constructor(props) {
    super(props);
    this.renderFloatContent = this.renderFloatContent.bind(this);
  }

  componentWillMount() {

  }

  render() {
    const {
      show,
      target,
      onCloseFloat,
    } = this.props;

    return (
      <Float
        container={global['--classtop-main-section']}
        show={show}
        target={target}
        floatWidth={250}
        onCloseFloat={onCloseFloat}
      >
        {this.renderFloatContent()}
      </Float>
    )
  }

  renderFloatContent() {
    const {attendeeInfo = {}} = this.props;
    const {attendee_name, attendee_email, attendee_phone, date_of_birth} = attendeeInfo

    return (
      <div className='attendee-detail-float container-fluid'>
        <div className='attendee_name'>{attendee_name}</div>
        <hr />
        <div className='birthday'>
          <p className='birthday-label'>{__('Date of Birth', 'registrationTable')}</p>
          <p className='birthday-input'>{ date_of_birth? moment(date_of_birth).format(__('MMM DD, YYYY', 'dateFormat')): 'N/A'}</p>
        </div>
        <div className='phoneNo'>
          <p className='phone-label'>{__('Phone No.', 'registrationTable')}</p>
          <p className='phone-input'>{attendee_phone}</p>
        </div>
        <div className='email'>
          <p className='email-label'>{__('Email', 'registrationTable')}</p>
          <p className='email-input'>{attendee_email}</p>
        </div>
      </div>
    );
  }

}

export default RegistrationTableFloat;



// WEBPACK FOOTER //
// ./src/template/Floats/RegistrationTableFloat/index.js